import { QuizTemplate } from "./types";
import { promptEnd, promptIntro } from "./utils";

export const beginnerIntro: QuizTemplate = {
  slug: "beginner-intro",
  titleHandle: "guide.beginnerIntro.title",
  shortTextHandle: "guide.beginnerIntro.shortText",
  longTextHandle: "guide.beginnerIntro.longText",
  level: "easy",
  questionPrompts: (userLanguageName: string, practiceLanguageName: string) => [
    {
      title: "Learn Basic Greetings and Phrases",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to Learn Basic Greetings and Phrases of ${practiceLanguageName}.
        The guide should explain concrete information about Basic Greetings and Phrases of ${practiceLanguageName}.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Familiarize Yourself with the Alphabet",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `that explains the alphabet of ${practiceLanguageName}. 
        The guide should explain concrete information about the alphabet of ${practiceLanguageName}.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Understand Pronunciation",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to understand pronunciation of ${practiceLanguageName}.
        The guide should explain concrete information about Pronunciation of ${practiceLanguageName}.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Start Building Your Vocabulary",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to Start Building my Vocabulary of ${practiceLanguageName}. The vocabulary should be within the categories:
        Food and Drink, Directions and Transportation, Family and Relationships, Everyday Objects, Shopping, Hobbies.
        The guide should tell me what concrete phrases mean and how to say them in ${practiceLanguageName}.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },

    {
      title: "Grasp Basic Grammar",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to Learn Basic Grammar of ${practiceLanguageName}.
        The guide should explain concrete information about Basic Grammar of ${practiceLanguageName}.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
  ],
};
